import {HStack, Icon, Text} from 'platform/foundation';

import {PersonnelOverviewItem} from '@dms/api/core';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {getPersonnelOverviewTotal} from '../utils/getPersonnelOverviewTotal';
import {OverviewRowButton} from './OverviewRowButton';

interface PersonnelOverviewAllRowProps extends TestIdProps {
  items: PersonnelOverviewItem[];
  isSelected: boolean;
  onClick: () => void;
}

export function PersonnelOverviewAllRow(props: PersonnelOverviewAllRowProps) {
  const total = getPersonnelOverviewTotal(props.items);
  const textColor = props.isSelected ? 'link' : 'primary';
  const iconColor = props.isSelected ? 'text.link' : 'text.primary';

  return (
    <OverviewRowButton
      type="button"
      onClick={props.onClick}
      aria-pressed={props.isSelected}
      data-testid={suffixTestId('personnelOverviewAllRow', props)}
    >
      <HStack spacing={2} align="center">
        <Icon value="action/done_all" size={4} color={iconColor} />
        <Text size="small" color={textColor}>
          {i18n.t('general.labels.all')}
        </Text>
        <Text size="small" color={textColor}>{`· ${total}`}</Text>
      </HStack>
    </OverviewRowButton>
  );
}
